import React, { PureComponent } from "react";
import { Icon } from "semantic-ui-react";
import styles from "./PasswordInput.module.css";

class PasswordInput extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			type: "password"
		};
	}

	handleShowHide = event => {
		event.preventDefault();
		event.stopPropagation();
		this.setState({
			type: this.state.type === "input" ? "password" : "input"
		});
		this.focus();
	};

	handleRef = c => {
		this.inputRef = c;
	};

	focus = () => {
		this.inputRef.focus();
	};

	render() {
		const { name, value, placeholder, onChange, disabled, icon } = this.props;
		const { type } = this.state;

		return (
			<div className={styles.inputContainer}>
				{icon && (
					<div className={styles.iconWrapper}>
						<Icon name={icon} />
					</div>
				)}
				<input
					disabled={disabled}
					className={`${styles.input} ${icon ? styles.hasIcon : ""}`}
					ref={this.handleRef}
					type={type}
					placeholder={placeholder}
					name={name}
					value={value}
					onChange={onChange}
				/>
				<div className={styles.showHide} onClick={this.handleShowHide}>
					<Icon name={type === "password" ? "eye" : "eye slash"} />
				</div>
			</div>
		);
	}
}

export default PasswordInput;
